(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      const precedingSection = this.header.previousElementSibling;
      const precedingSectionHeight = precedingSection?.classList.contains('announcement-bar-section')
        ? precedingSection.offsetHeight
        : 0;

      this.header.style.setProperty('--header-transparent-offset', `${precedingSectionHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moud-dans-le-temps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moud-timeline')) {
    customElements.define('moud-timeline', class extends HTMLElement {
      connectedCallback() {
        this.fill = this.querySelector('[data-fill]');
        this.rail = this.querySelector('.mdt__rail');
        this.lits = Array.from(this.querySelectorAll('[data-lit]'));
        this.visuals = Array.from(this.querySelectorAll('.mdt__img, .mdt__chip'));
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this.update(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.classList.add('is-ready');
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      update() {
        const trigger = window.innerHeight * 0.6;
        const rail = this.rail.getBoundingClientRect();
        this.fill.style.height = Math.max(0, Math.min(rail.height, trigger - rail.top)) + 'px';
        let phase = '0';
        this.lits.forEach((el) => {
          const lit = el.getBoundingClientRect().top + 12 < trigger;
          el.classList.toggle('is-lit', lit);
          if (lit) phase = el.closest('.mdt__group').dataset.phase;
        });
        this.visuals.forEach((el) => el.classList.toggle('is-on', el.dataset.phase === phase));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moud-science-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moud-science-two')) {
    customElements.define(
      'moud-science-two',
      class MoudScienceTwo extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.dialog = this.querySelector('.moud-science-two__dialog');
          this.viewport = this.querySelector('[data-mst-viewport]');
          this.closeButton = this.querySelector('[data-mst-close]');
          this.openers = [...this.querySelectorAll('[data-mst-open]')];
          this.desktopZoom = Number.parseInt(this.dataset.desktopZoom, 10) || 140;
          this.activeOpener = null;
          this.previousOverflow = '';
          this.handleOpen = this.handleOpen.bind(this);
          this.handleCloseClick = this.handleCloseClick.bind(this);
          this.handleDialogClick = this.handleDialogClick.bind(this);
          this.handleClose = this.handleClose.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.openers.forEach((opener) => opener.addEventListener('click', this.handleOpen));
          this.closeButton?.addEventListener('click', this.handleCloseClick);
          this.dialog?.addEventListener('click', this.handleDialogClick);
          this.dialog?.addEventListener('close', this.handleClose);
          window.addEventListener('resize', this.handleResize, { passive: true });
        }

        disconnectedCallback() {
          this.openers?.forEach((opener) => opener.removeEventListener('click', this.handleOpen));
          this.closeButton?.removeEventListener('click', this.handleCloseClick);
          this.dialog?.removeEventListener('click', this.handleDialogClick);
          this.dialog?.removeEventListener('close', this.handleClose);
          window.removeEventListener('resize', this.handleResize);
        }

        handleOpen(event) {
          const opener = event.currentTarget;
          const id = opener.dataset.mstOpen;
          const template = [...this.querySelectorAll('[data-mst-template]')].find(
            (candidate) => candidate.dataset.mstTemplate === id
          );
          if (!this.dialog || !this.viewport) return;

          let dialogLabel = opener.getAttribute('aria-label') || '';

          if (template) {
            this.viewport.replaceChildren(template.content.cloneNode(true));
            dialogLabel = template.dataset.mstLabel || dialogLabel;
          } else {
            const sourceSvg = opener.querySelector('.moud-science-two__chart-svg');
            if (!sourceSvg) return;

            const canvas = document.createElement('div');
            const popupSvg = sourceSvg.cloneNode(true);
            canvas.className = 'moud-science-two__popup-canvas';
            canvas.dataset.mstCanvas = '';
            popupSvg.classList.add('moud-science-two__popup-image');
            popupSvg.removeAttribute('aria-labelledby');
            popupSvg.setAttribute('role', 'img');
            popupSvg.setAttribute('aria-label', dialogLabel);
            canvas.append(popupSvg);
            this.viewport.replaceChildren(canvas);
          }

          this.activeOpener = opener;
          this.dialog.setAttribute('aria-label', dialogLabel);
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');

          const media = this.viewport.querySelector('img, svg');
          if (media instanceof HTMLImageElement && !media.complete) {
            media.addEventListener('load', () => this.fitMedia(media), { once: true });
          } else {
            this.fitMedia(media);
          }
          this.closeButton?.focus({ preventScroll: true });
        }

        fitMedia(media) {
          if (!media || !this.viewport) return;

          let naturalWidth = media.naturalWidth || 1;
          let naturalHeight = media.naturalHeight || 1;

          if (media instanceof SVGSVGElement) {
            naturalWidth = media.viewBox.baseVal.width || 700;
            naturalHeight = media.viewBox.baseVal.height || 440;
          }

          const availableWidth = this.viewport.clientWidth;
          const availableHeight = this.viewport.clientHeight;
          const fitScale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
          const desktop = window.matchMedia('(min-width: 750px)').matches;
          const zoom = desktop ? this.desktopZoom / 100 : 1;
          const displayWidth = Math.max(1, Math.round(naturalWidth * fitScale * zoom));
          const displayHeight = Math.max(1, Math.round(naturalHeight * fitScale * zoom));
          const canvas = media.closest('[data-mst-canvas]');
          media.style.width = `${displayWidth}px`;
          media.style.height = `${displayHeight}px`;
          if (canvas) {
            canvas.style.width = `${Math.max(availableWidth, displayWidth)}px`;
            canvas.style.height = `${Math.max(availableHeight, displayHeight)}px`;
          }
          requestAnimationFrame(() => {
            this.viewport.scrollLeft = Math.max(0, (this.viewport.scrollWidth - this.viewport.clientWidth) / 2);
            this.viewport.scrollTop = Math.max(0, (this.viewport.scrollHeight - this.viewport.clientHeight) / 2);
          });
        }

        handleResize() {
          if (!this.dialog?.hasAttribute('open')) return;
          const media = this.viewport?.querySelector('img, svg');
          if (media) this.fitMedia(media);
        }

        handleCloseClick() {
          this.closeDialog();
        }

        handleDialogClick(event) {
          if (event.target === this.dialog) this.closeDialog();
        }

        closeDialog() {
          if (!this.dialog?.hasAttribute('open')) return;
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else {
            this.dialog.removeAttribute('open');
            this.handleClose();
          }
        }

        handleClose() {
          this.viewport?.replaceChildren();
          document.documentElement.style.overflow = this.previousOverflow;
          this.activeOpener?.focus({ preventScroll: true });
          this.activeOpener = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moud-video-bubbles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moud-video-bubbles')) {
    customElements.define(
      'moud-video-bubbles',
      class MoudVideoBubbles extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.dialog = this.querySelector('.moud-video-bubbles__dialog');
          this.stage = this.querySelector('[data-mvb-stage]');
          this.closeButton = this.querySelector('[data-mvb-close]');
          this.openers = [...this.querySelectorAll('[data-mvb-open]')];
          this.previews = [...this.querySelectorAll('[data-mvb-preview]')];
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.previousOverflow = '';
          this.activeOpener = null;
          this.handleOpen = this.handleOpen.bind(this);
          this.handleCloseClick = this.handleCloseClick.bind(this);
          this.handleDialogClick = this.handleDialogClick.bind(this);
          this.handleDialogClose = this.handleDialogClose.bind(this);
          this.openers.forEach((opener) => opener.addEventListener('click', this.handleOpen));
          this.closeButton?.addEventListener('click', this.handleCloseClick);
          this.dialog?.addEventListener('click', this.handleDialogClick);
          this.dialog?.addEventListener('close', this.handleDialogClose);
          this.observePreviews();
        }

        disconnectedCallback() {
          this.openers?.forEach((opener) => opener.removeEventListener('click', this.handleOpen));
          this.closeButton?.removeEventListener('click', this.handleCloseClick);
          this.dialog?.removeEventListener('click', this.handleDialogClick);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
          this.loadObserver?.disconnect();
          this.playObserver?.disconnect();
        }

        observePreviews() {
          if (!this.previews.length) return;
          if (!('IntersectionObserver' in window)) {
            this.previews.forEach((preview) => this.hydratePreview(preview));
            return;
          }
          const distance = Number.parseInt(this.dataset.lazyDistance, 10) || 0;
          this.loadObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.loadObserver.unobserve(entry.target);
              this.hydratePreview(entry.target);
            });
          }, { rootMargin: `${distance}px 0px` });
          this.previews.forEach((preview) => this.loadObserver.observe(preview));
        }

        hydratePreview(preview) {
          if (preview.dataset.loaded === 'true') return;
          const template = preview.querySelector('[data-mvb-preview-template]');
          if (!template) return;
          preview.dataset.loaded = 'true';
          preview.append(template.content.cloneNode(true));
          const video = preview.querySelector('video');
          if (!video) return;
          video.addEventListener('loadeddata', () => preview.classList.add('is-loaded'), { once: true });
          video.load();
          if (this.reducedMotion) return;
          if (!('IntersectionObserver' in window)) {
            video.play().catch(() => {});
            return;
          }
          if (!this.playObserver) {
            this.playObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                const targetVideo = entry.target.querySelector('video');
                if (!targetVideo) return;
                if (entry.isIntersecting) targetVideo.play().catch(() => {});
                else targetVideo.pause();
              });
            }, { threshold: 0.15 });
          }
          this.playObserver.observe(preview);
        }

        handleOpen(event) {
          const opener = event.currentTarget;
          const id = opener.dataset.mvbOpen;
          const template = [...this.querySelectorAll('[data-mvb-modal-template]')].find(
            (candidate) => candidate.dataset.mvbModalTemplate === id
          );
          if (!template || !this.dialog || !this.stage) return;
          this.activeOpener = opener;
          this.stage.replaceChildren(template.content.cloneNode(true));
          this.dialog.dataset.ratio = template.dataset.mvbRatio || 'portrait';
          this.dialog.setAttribute('aria-label', template.dataset.mvbLabel || '');
          const iframe = this.stage.querySelector('[data-mvb-vimeo-src]');
          if (iframe) iframe.src = iframe.dataset.mvbVimeoSrc;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
          const video = this.stage.querySelector('video');
          if (video) {
            video.load();
            video.play().catch(() => {});
          }
          this.closeButton?.focus({ preventScroll: true });
        }

        handleCloseClick() {
          this.closeDialog();
        }

        handleDialogClick(event) {
          if (event.target === this.dialog) this.closeDialog();
        }

        closeDialog() {
          if (!this.dialog?.hasAttribute('open')) return;
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else {
            this.dialog.removeAttribute('open');
            this.handleDialogClose();
          }
        }

        handleDialogClose() {
          this.stage?.replaceChildren();
          document.documentElement.style.overflow = this.previousOverflow;
          this.activeOpener?.focus({ preventScroll: true });
          this.activeOpener = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
